const MapViewType = Object.freeze({
  DEFAULT: "DEFAULT",
  MAP: "MAP",
  STREET: "STREET",
  AERIAL: "AERIAL",
  SEARCH: "SEARCH",
  DIRECTIONS: "DIRECTIONS"
});
export default MapViewType;